import { css } from '@linaria/core';
import { breakpoints, theming } from 'styles/utils';
export const container = "omponents__Table__Pagination__Pagination_styles_tsx-container-c1q1j0qi";
export const pages = "omponents__Table__Pagination__Pagination_styles_tsx-pages-pvt5ekc";
export const inactiveBtn = "omponents__Table__Pagination__Pagination_styles_tsx-inactiveBtn-i17hm1if";
export const whiteBtn = "omponents__Table__Pagination__Pagination_styles_tsx-whiteBtn-w1p34qs5";

require("./Pagination.styles.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Pagination.styles.tsx");